<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-transparent";
    export let hover = "group-hover:stroke-mblue";
    export let strokeWidth = "1.5";
    export let classList = "aspect-ratio transition-all";
</script>

<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
>
    <g clip-path="url(#clip0_301_15156)">
        <path d="M12 15.5C14.21 15.5 16 13.71 16 11.5V6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V11.5C8 13.71 9.79 15.5 12 15.5Z" />
        <path d="M4.3501 9.65002V11.35C4.3501 15.57 7.7801 19 12.0001 19C16.2201 19 19.6501 15.57 19.6501 11.35V9.65002" />
        <path d="M10.6101 6.43C11.5101 6.1 12.4901 6.1 13.3901 6.43" />
        <path d="M11.2 8.54995C11.73 8.40995 12.28 8.40995 12.81 8.54995" />
        <path d="M12 19V22" />
    </g>
    <defs>
        <clipPath id="clip0_301_15156">
            <rect width="24" height="24" fill="white"/>
        </clipPath>
    </defs>
</svg>
